module.exports = __webpack_public_path__ + "static/media/brand_logo.bcece2be.png";